<template>
    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('offers.declineOffer')"></page-title>
    </div>

    <jet-form-section @submitted="decline()">
        <template #form>
            <!-- Card Decline Offer -->
            <form-card
                :title="$t('offers.declineOffer')"
                :description="$t('offers.declineOfferConfirm')"
            >
                <div class="col-span-6">
                    <label for="reason" class="block text-sm font-medium text-gray-700">{{
                        $t("offers.reason")
                    }}</label>
                    <textarea
                        type="text"
                        name="reason"
                        id="reason"
                        v-model="form.updateState.reason"
                        class="focus:ring-minplan-blue focus:border-minplan-blue w-full mt-3"
                        autofocus
                    ></textarea>
                    <jet-input-error
                        :message="form.errors['updateState.reason']"
                        class="mt-2"
                    />
                </div>
            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">
                <button
                    @click="cancel"
                    type="button"
                    class="inline-block uppercase font-semibold text-xs tracking-widest"
                >
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    class="ml-3"
                >
                    {{ $t("actions.decline") }}
                </primary-button>
            </div>
        </template>
    </jet-form-section>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";

export default defineComponent({
    props: ["modification", "patchModificationRoute"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
    },
    setup() {
        const form = useForm({
            updateState: {
                transition: "decline",
                reason: null,
            },
        });

        return { form };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        decline() {
            this.form.patch(this.patchModificationRoute, {
                onSuccess: () =>
                    this.$notify({
                        group: "success",
                        title: "actions.success",
                        text: "orderModifications.updated",
                    }),
            });
        },
    },
});
</script>

<style scoped></style>
